import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import i18next from "i18next";
import { withRouter } from 'react-router';
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam.js";
import PopupWrapper from "../Common/PopupWrapper";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

class CreateMatHelp extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isDataReady: false,
      showMessage: false,
      messageText: "",
      messageTitle: ""
    };
  }

  componentDidMount() {
    console.log("CreateMatHelp mount");
    this.onInit();
  }

  componentWillUnmount() {
    console.log("CreateMatHelp unmount");
  }

  onInit = async () => {
    try {
      this.setState({isDataReady: false});

      await this.props.dataItem.reset();
      await this.props.dispatch(
          this.props.dataItem.initialize(
              {MatHelpTypeId: this.props.typeInfo.typeId},
              {refresh: false, withParams: true, newItem: true, commandId: this.props.commandId}
          )
      );

      if (!this.props.dataItem.isError) {
        this.setState({isDataReady: true});
      }
    } catch (e) {
      await this.props.dispatch(e);
    }
  }

  onSave = () => {
    return confirm(i18next.t("CreateMatHelp_SaveAgreement"))
        .then(() => this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params))
            .then(() => {
                  this.setState({
                    messageText: this.props.dataItem.isError ? i18next.t(this.props.typeInfo.ErrorMessage) : i18next.t(this.props.typeInfo.SuccessMessage),
                    messageTitle: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                    showMessage: !this.props.dataItem.isError
                  });
                }
            )
        )
        .catch(() => {
        });
  }

  onMessageClose = () => {
    if (this.props.onClose)
      this.props.onClose()
  }

  render() {
    const renderButtons = () => {
      return (<div className="modal-footer text-right">
        <button type="button" disabled={!this.state.isDataReady}
                className="btn btn-regular -goahead  ml1ex" data-dismiss="modal"
                onClick={this.onSave}>{i18next.t("SendStatement")}</button>
        <button type="button" className="btn btn-regular ml1ex" data-dismiss="modal"
                onClick={this.props.onClose}>{i18next.t("Close")}</button>
      </div>)
    }

    let paramsCount = this.props.dataItem_Params.isInitialized && this.props.dataItem_Params.rawData.ResultFieldInfo.filter(fi => !fi.IsHidden && fi.Title).length;

    return (
        <PopupWrapper popupVisible={true} title={i18next.t(this.props.typeInfo.Title)} renderButtons={renderButtons}
                      instructionId={this.props.typeInfo.typeId}
                      staticTitle={i18next.t(this.props.typeInfo.Title)}
                      onClose={this.props.onClose}>
          <div>
            {!this.state.isDataReady ?
                i18next.t('LoadingLabel')
                : <React.Fragment>
                  <MessageBox visible={this.state.showMessage}
                              title={this.state.messageTitle}
                              messageText={this.state.messageText}
                              onClose={this.onMessageClose}/>
                  {/*
              {this.props.typeInfo.Instruction &&
                <PlaceholderWrapper placeholderId="create_mat_help_10"
                                    title={<><i className='fa fa-info'/> {i18next.t("Instruction")}</>}>
                  {this.props.typeInfo.Instruction}
                </PlaceholderWrapper>
              }
*/}

                  <PlaceholderWrapper placeholderId={this.props.typeInfo.typeId} showHeaderTitle={false}
                                      canCollapse={false}
                                      title={i18next.t(this.props.typeInfo.Title)}
                                      showInstruction={false}
                                      showSplitterLine={false}>
                    {paramsCount > 0 &&
                        <ComplexParam dataItem={this.props.dataItem_Params}
                                      parentDataItem={this.props.dataItem}
                                      showSearchBar={false} showApplyButton={false} autoApplyParams={false}
                                      rootPath={this.props.dataItemPath} renderParams={paramRender}/>
                    }
                  </PlaceholderWrapper>
                </React.Fragment>
            }
          </div>
        </PopupWrapper>
    )
  }
}

CreateMatHelp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dataItem: PropTypes.object,
  dataItem_Params: PropTypes.object,
  onClose: PropTypes.func,
  typeInfo: PropTypes.object.isRequired
};

CreateMatHelp.defaultProps = {
};

function mapStateToProps(state, ownProps) {
  return {
    dataItem: state.matHelpState[ownProps.typeInfo.ReducerName],
    dataItem_Params: state.matHelpState[ownProps.typeInfo.ReducerName + "_Params"]
  }
}

export default withRouter(connect(mapStateToProps)(CreateMatHelp));